export const environment = {
  production: true,
  apiBase:'https://apiunify.academia.cl'
 // apiBase:'https://apiunify.academia.cl'
};
